/**
 * Ограничивает счетчик непрочитанных сообщений компактным значением для меню
 */
export function unreadCountBadgeLabel(count) {
  return Number(count) > 99 ? "99+" : String(count);
}

/**
 * Добавляет счетчик непрочитанных чатов в title страницы и убирает старый счетчик.
 */
export function chatUnreadDocumentTitle(title, unreadCount) {
  const cleanTitle = String(title || "Trucko").replace(
    /^\(\d+\+?\)\s+/,
    ""
  );
  const normalizedUnreadCount = Number(unreadCount || 0);

  if (normalizedUnreadCount <= 0) return cleanTitle;

  return `(${unreadCountBadgeLabel(normalizedUnreadCount)}) ${cleanTitle}`;
}

/**
 * Собирает короткий текст toast-уведомления о новом сообщении в чате.
 */
export function chatUnreadNotificationMessage(conversation) {
  const name = conversation?.name || `Чат #${conversation?.id}`;
  const lastMessage = String(conversation?.last_message_text || "").trim();

  return lastMessage
    ? `Новое сообщение от ${name}: ${lastMessage}`
    : `Новое сообщение от ${name}`;
}

/**
 * Синхронизирует badge установленного PWA с количеством непрочитанных чатов.
 */
export function syncChatUnreadAppBadge(unreadCount) {
  if (typeof navigator === "undefined") return;

  const normalizedUnreadCount = Number(unreadCount || 0);

  if (
    normalizedUnreadCount > 0 &&
    typeof navigator.setAppBadge === "function"
  ) {
    const badgePromise = navigator.setAppBadge(normalizedUnreadCount);
    if (badgePromise?.catch) badgePromise.catch(() => {});
    return;
  }

  if (
    normalizedUnreadCount <= 0 &&
    typeof navigator.clearAppBadge === "function"
  ) {
    const badgePromise = navigator.clearAppBadge();
    if (badgePromise?.catch) badgePromise.catch(() => {});
  }
}
